import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  BASE_URL,
  dropdownFetch,
  getCurrentDateTime,
  getDateDifference,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { OPDBillingDetailForm } from './OPDBillingDetailForm';
import { BANK_CASH, BILL_TYPE, RECEIPT_MODE, YES_NO } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { IPDSearchHandler } from './utils';
import { CustomButtonn } from '../../../../../components';
import { calculateAge } from '../../../../../utils';
import { IpdBillingDetailForm } from './IpdBillingDetailsForm';
import axios from 'axios';

const BILL_TABLE_HEADER = [
  {
    header: 'Type',
    accessor: 'type'
  },
  {
    header: 'Operating Doctor',
    accessor: (row) => row?.doctor
  },
  {
    header: 'Service Name',
    accessor: (row) =>
      row?.service_name ||
      row?.testDetails?.test_name?.test_name ||
      row?.serviceDetails?.service_name?.service_name ||
      ''
  },
  {
    header: 'Qty',
    accessor: 'quantity'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: (row) => row.amount
  },
  {
    header: 'Disc. Amt',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: (row) => row.net_amt
  }
];

const TABLE_HEADER = [
  {
    header: 'Bill No',
    accessor: 'bill_no'
  },
  {
    header: 'Bill Date',
    accessor: (row) => `${getCurrentDateTime('date', row.date)}`
  },
  {
    header: 'UHID',
    accessor: 'patient.uhid'
  },
  {
    header: 'IPD No',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor_name'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const INDENT_TABLE_HEADER = [
  {
    header: 'Indent No',
    accessor: 'indent_no'
  },
  {
    header: 'Indent Date',
    accessor: (row) => `${getCurrentDateTime('date', row.date)}`
  },
  {
    header: 'IPD No',
    accessor: 'ipd_no'
  },
  {
    header: 'Uhid',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => `${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name} `
  },
  {
    header: 'Doctor',
    accessor: (row) => row?.patientIpdInfo?.doctorInfo?.name
  },
  {
    header: 'Sponsor',
    accessor: (row) => row?.patientInfo?.sponsorInfo?.name
  },
  {
    header: 'Ward',
    accessor: (row) => row?.wardInfo?.name
  }
];

const LAB_INDENT_TABLE_HEADER = [
  {
    header: 'Indent No',
    accessor: 'indent_no'
  },
  {
    header: 'Indent Date',
    accessor: (row) => `${getCurrentDateTime('date', row.date)}`
  },
  {
    header: 'IPD No',
    accessor: 'ipd_no'
  },
  {
    header: 'Uhid',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => `${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name} `
  },
  {
    header: 'Doctor',
    accessor: (row) => row?.patientIpdInfo?.doctorInfo?.name
  },
  {
    header: 'Sponsor',
    accessor: (row) => row?.patientInfo?.sponsorInfo?.name
  },
  {
    header: 'Ward',
    accessor: (row) => row?.wardInfo?.name
  }
];
const initialIPDBillingDataObj = {
  data: [],
  loading: false
};

const initialPendingServiceIndentDataObj = {
  data: [],
  loading: false
};

const initialPendingLabIndentDataObj = {
  data: [],
  loading: false
};
export const IndoorService = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const doctorIDRef = useRef();
  const sponsorIDRef = useRef();
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [IPDSearchDialogOpen, setIPDSearchDialogOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [ipdBillingDataObj, setIpdBillingDataObj] = useState(initialIPDBillingDataObj);
  const [opdTodayBillingDataObj, setOpdTodayBillingDataObj] = useState(initialIPDBillingDataObj);
  const [openQueryTodayDialog, setOpenQueryTodayDialog] = useState(false);
  const [pendingServiceIndentDataObj, setPendingServiceIndentDataObj] = useState(initialPendingServiceIndentDataObj);
  const [pendingLabIndentDataObj, setPendingLabIndentDataObj] = useState(initialPendingLabIndentDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [input, setInput] = useState('');
  const [inputToday, setInputToday] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [originalIndentData, setOriginalIndentData] = useState([]);
  const [originalIndentDatas, setOriginalIndentDatas] = useState([]);
  const [indentInputs, setIndentInputs] = useState('');
  const [pendingServiceIndentDialogueOpen, setPendingServiceIndentDialogueOpen] = useState(false);
  const [pendingLabIndentDialogueOpen, setPendingLabIndentDialogueOpen] = useState(false);
  const [serviceDropdown, setSeriveDropdown] = useState([]);
  const [testDropdown, setTestDropdown] = useState([]);
  const [indentTests, setIndentTests] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [startDateInput,setStartDateInput] = useState('')
  const [endDateInput,setEndDateInput] = useState('')

  const user = JSON.parse(localStorage.getItem('user'));
  const netAmtRef = useRef(0);

  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  const doctorRef = useRef();
  const [indentInput, setIndentInput] = useState('');

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' '),
        patient_name: Yup.string().required(' '),
        doctor: Yup.string().required(' '),
        sponsor: Yup.string().required(' '),
        bill: Yup.object().shape({
          // rec_amt_1: Yup.number().min(0, ' '),
          // rec_amt_2: Yup.number().min(0, ' '),
          pay_mode: Yup.string().required(' ')
        })
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      bill: {
        pay_mode:"Credit",
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        disc_per: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const discAmt = watch('bill.disc_amt'); // Watch discount amount
  const netAmtWatch = watch('bill.net_amt'); // Watch net amount
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  const payMode = watch('bill.pay_mode');
  const discPer = watch('bill.disc_per'); // Watch discount percentage

  // Calculate the initial values from the detailList
  useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let gst_amt = 0;
    let net_amt = 0;

    if (detailList) {
      detailList.forEach((detail) => {
        total_qty += detail.quantity;
        total_amt += detail.amount;
        gst_amt += detail.gst_amt;
        net_amt += detail.net_amt;
      });
    }

    // Set initial values for total amount, net amount, and other fields
    setValue('bill.total_qty', total_qty);
    setValue('bill.total_amt', total_amt);
    setValue('bill.gst_amt', gst_amt);
    setValue('bill.net_amt', net_amt); // Set the initial net_amt from the detailList
    netAmtRef.current = net_amt; // Store initial net_amt in useRef
  }, [detailList, setValue]);

  // Handle discount changes and adjust the net amount
  useEffect(() => {
    if (discAmt && netAmtWatch) {
      const adjustedNetAmt = netAmtRef.current - discAmt; // Subtract the discount from the initial net amount

      // Update the fields with the adjusted values
      setValue('bill.net_amt', adjustedNetAmt); // Update net_amt after discount
      setValue('bill.rec_amt_1', adjustedNetAmt); // Set rec_amt_1 to the adjusted net amount
      setValue('bill.total_recpt', adjustedNetAmt); // Set total_recpt to the adjusted net amount

      // Calculate and set the discount percentage
      const calculatedDiscPer = ((discAmt / netAmtRef.current) * 100).toFixed(2); // Calculate discount percentage
      setValue('bill.disc_per', parseFloat(calculatedDiscPer)); // Update disc_per with calculated value
    }
  }, [discAmt, netAmtWatch, setValue]);

  // Handle receipt and balance amount calculation based on payment mode
  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;

    if (payMode === 'CASH') {
      setValue('bill.rec_amt_1', netAmtWatch); // Set the total net amount after discount to rec_amt_1
      setValue('bill.rec_amt_2', 0); // Clear rec_amt_2
      setValue('bill.balance_amt', 0); // Set balance amount to 0
      setValue('bill.total_recpt', netAmtWatch); // Set total receipt to net amount after discount
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('bill.rec_amt_1', 0); // Clear rec_amt_1 for non-cash payment modes
      setValue('bill.rec_amt_2', netAmtWatch); // Set the total net amount after discount to rec_amt_2
      setValue('bill.balance_amt', 0); // Set balance amount to 0
      setValue('bill.total_recpt', netAmtWatch); // Set total receipt to net amount after discount
    } else if (payMode === 'Credit') {
      setValue('bill.rec_amt_1', 0); // Clear rec_amt_1 for credit payment
      setValue('bill.rec_amt_2', 0); // Clear rec_amt_2 for credit payment
      setValue('bill.balance_amt', balanceAmt); // Set balance amount to remaining balance
      setValue('bill.total_recpt', 0); // Set total receipt to 0 since no payment is made
    } else {
      // Default case when no payment mode is matched
      setValue('bill.total_recpt', total_recpt);
      setValue('bill.balance_amt', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  useEffect(() => {
    if (selectedRecord) {
      console.log();
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'ipd_no'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedBillDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedBillDate);
      setValue('time', selectedRecord?.time);
      setValue('ipd_no', selectedRecord.ipd_no);
      setDetailList(selectedRecord.service_items);
      searchIPDDetails(selectedRecord.ipd_no);
    } else {
      reset();
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the service first', { variant: 'warning' });
      return;
    }
    let editFlag = false;
    setLoading(true);
    const payload = {
      ipd_no: formValues.ipd_no,
      ...formValues,
      ...formValues.bill,
      service_items: detailList
    };
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/ipd-billing-edit' : '/ipd-billing-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} IPD Bill`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      setDetailList([]);

      reset();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} IPD Bill`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) => prev.filter((data) => data.service !== rowId));
  };

  const onDetailAddHandler = (data) => {
    const existingDetail = detailList.find(({ service }) => service === data.service);
    if (existingDetail) {
      toast('OPD Type Service already chosen', { variant: 'error' });
      return;
    }
    const serviceName = data?.serviceName;

    setDetailList((prev) => [
      ...prev,
      {
        ...data,
        service_name: serviceName
      }
    ]);
    toast('Service Added Successfully', { variant: 'success' });
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/ipd-billing-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel IPD Bill', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel IPD Bill', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/ipd-billing-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted IPD Bill', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete IPD Bill', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setIpdBillingDataObj({ loading: true });
    const response = await request('/ipd-billing-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setIpdBillingDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIpdBillingDataObj({ loading: false });
    }
  };

  const TodayBilling = async () => {
    setOpenQueryTodayDialog(true);
    setOpdTodayBillingDataObj({ loading: true, data: [] });
    const query = {};

    query.today = 1;
    const response = await request('/ipd-billing-list', {
      method: 'GET',
      query: query
    });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdTodayBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdTodayBillingDataObj({ loading: false, data: [] });
    }
  };

  const handleChangeToday = (e) => {
    const newInput = e.target.value;
    setInputToday(newInput);
  };

  useEffect(() => {
    handlePatientDataToday();
  }, [inputToday]);

  useEffect(() => {
    if (ipdBillingDataObj.data && ipdBillingDataObj.data.length > 0) {
      setOriginalData(ipdBillingDataObj.data);
      setIsFiltered(false);
    }
  }, [ipdBillingDataObj.data]);

  useEffect(() => {
    handlePatientData();
  }, [input]);

  const handlePatientData = async () => {
    const lowercasedInput = input.toLowerCase().trim();

    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput ;
        query.endDate = endDateInput;
      }
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/ipd-billing-list', {
        method: 'GET',
        query: query
      });

      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setIpdBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setIpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setIpdBillingDataObj({ loading: false, data: [] });
    }
  };

  const handlePatientDataToday = async () => {
    const lowercasedInput = inputToday.toLowerCase().trim();
    setOpdTodayBillingDataObj({ loading: true, data: [] });
    try {
      const query = {};
      query.today = 1;
      query.patientName = lowercasedInput;
      const response = await request('/ipd-billing-list', {
        method: 'GET',
        query: query
      });

      if (response.success && Array.isArray(response.data)) {
        console.log('rdrdrd');
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setOpdTodayBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setOpdTodayBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOpdTodayBillingDataObj({ loading: false, data: [] });
    }
  };
  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const searchIPDDetails = async (ipd_no) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipd_no
    });
    if (response?.success) {
      if (!response?.data) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        const { data: patientData } = response;
        setValue('ipd_no', ipd_no);
        setValue('patient_name', `${patientData?.patient?.first_name} ${patientData?.patient?.last_name}`);
        setValue('patient_suffix', patientData?.patient?.name_suffix);
        setValue('ward', patientData?.consultant_detail.room?.ward?.name);
        setValue('uhid', patientData?.uhid);
        const { year } = getDateDifference(new Date(patientData?.patient.dob));
        setValue('age', year);
        doctorIDRef.current = patientData.patient.consultant?._id;
        setValue('doctor', patientData.consultant_detail?.doctor?.name);
        setValue('room_no', patientData.consultant_detail?.room?.room_no);
        setValue('bed_no', patientData.consultant_detail?.bed_no);
        setValue('sponsor', patientData.patient.sponsor?.name);
        sponsorIDRef.current = patientData.patient.sponsor?._id;
      }
    }
    setLoading(false);
  };

  const fetchIpdPatient = async () => {
    setPendingServiceIndentDialogueOpen(true);
    setPendingServiceIndentDataObj({ loading: true });
    try {
      const indentResponse = await request('/indent-ipd-billing-lists', { method: 'GET' });
      if (indentResponse.success) {
        const filteredIndentData = indentResponse.data.filter(
          (item) => item.authorize === true && item.indent_type === 'S' && item.patient_type === 'ipd_indent'
        );
        setPendingServiceIndentDataObj({ loading: false, data: filteredIndentData });
      } else {
        toast('Error in fetching indent list data', { variant: 'error' });
        setPendingServiceIndentDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching IPD patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPendingServiceIndentDataObj({ loading: false });
    }
  };

  const fetchIpdPatients = async () => {
    setPendingLabIndentDialogueOpen(true);
    setPendingLabIndentDataObj({ loading: true });
    try {
      const indentResponse = await request('/indent-ipd-billing-lists', { method: 'GET' });
      if (indentResponse.success) {
        const indentData = indentResponse.data;
        const filteredIndentData = indentData.filter(
          (item) => item.authorize === true && item.indent_type === 'L' && item.patient_type === 'ipd_indent'
        );
        setPendingLabIndentDataObj({ loading: false, data: filteredIndentData });
      } else {
        toast('Error in fetching indent list data', { variant: 'error' });
        setPendingLabIndentDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching IPD patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPendingLabIndentDataObj({ loading: false });
    }
  };

  const getTestDropdown = useCallback(async () => {
    const data = await dropdownFetch('lis-test');
    setIndentTests(data);
    setTestDropdown(data);
  }, []);

  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service');
    setSeriveDropdown(data);
  }, []);

  useEffect(() => {
    getTestDropdown();
    getServiceDropdown();
  }, [getTestDropdown, getServiceDropdown]);

  const getServiceDataById = useCallback(async (selectedSponser, serviceIds) => {
    setIsLoading(true);
    try {
      if (!selectedSponser) {
        console.error('No sponsor selected.');
        return;
      }
      const response = await axios.post(
        `${BASE_URL}/price-list-master/listByServiceIds?sponsorName=${selectedSponser}`,
        { serviceIds: serviceIds }
      );
      const { data: newData } = response.data;
      return newData;
      // setServiceIdsData(newData);
    } catch (error) {
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getLabDataById = useCallback(async (selectedSponser, serviceIds) => {
    setIsLoading(true);
    try {
      if (!selectedSponser) {
        console.error('No sponsor selected.');
        return;
      }
      const response = await axios.post(
        `${BASE_URL}/lab-price-list-master/listByLabIds?sponsorName=${selectedSponser}`,
        { serviceIds: serviceIds }
      );
      const { data: newData } = response.data;
      return newData;
      // setLabIdsData(newData);
    } catch (error) {
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleRowClick = async (row) => {
    console.log(row, 'HELLLO rOWS I SHERE');
    const pendingIndentData = row.items;
    const serviceIds = row.items.map((item) => item.serviceDetails.service_name?._id);
    const labIds = row.items.map((item) => item.testDetails.test_name?._id);
    const serviceIdsData = await getServiceDataById(row?.patientInfo?.sponsorInfo?._id, serviceIds);
    const labIdsData = await getLabDataById(row?.patientInfo?.sponsorInfo?._id, labIds);

    doctorRef.current = row.patientIpdInfo?.doctorInfo?.name;
    if (serviceIdsData) {
      const updatedTestData = pendingIndentData.map((service) => {
        const matchedTest = serviceIdsData.find((inputValues) =>
          inputValues.inputValues.some((input) => input.service === service?.service)
        );
        console.log('HELLLO SERVICE IDS DATA IS HERE', serviceIdsData);
        if (matchedTest) {
          const matchedService = matchedTest.inputValues.find((input) => input.service === service?.service);
          console.log(matchedService, 'HELLLLOSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS');
          return {
            ...service,
            service: matchedService?.service,
            type: service?.serviceDetails?.service_name?.type,
            quantity: service.quantity,
            rate: matchedService?.['Ipd Charge'],
            amount: service.quantity * matchedService?.['Ipd Charge'],
            net_amt: service.quantity * matchedService?.['Ipd Charge'],
            disc_amt: 0,
            doctor: doctorRef.current,
            _id: matchedService?._id
          };
        }
        return service;
      });
      setPendingServiceIndentDialogueOpen(false);
      setValue('ipd_no', row.ipd_no);
      setValue('patient_suffix', row?.patient?.name_suffix);
      setValue('patient_name', `${row.patient.first_name} ${row.patient.last_name}`);
      setValue('uhid', `${row.uhid}`);
      setValue('bed_no', `${row.patientIpdInfo?.consultant_detail?.bed_no}`);
      setValue('doctor', `${row.patientIpdInfo?.doctorInfo?.name}`);
      setValue('ward', `${row.wardInfo?.name}`);
      setValue('sponsor', `${row.patientInfo?.sponsorInfo?.name}`);
      setValue('age', `${calculateAge(row.patient?.dob)}`);
      setValue('room_no', row.roomInfo.room_no);
      setValue('indent_no', row.indent_no);
      setDetailList(updatedTestData);
    }
  };

  console.log(detailList, 'HELLLO DETAILS LIST');
  const handleRowClicks = async (row) => {
    console.log(row, 'HELLLO rOWS I SHERE');
    const pendingIndentData = row.items;
    const labIds = row.items.map((item) => item.testDetails.test_name?._id);
    const labIdsData = await getLabDataById(row?.patientInfo?.sponsorInfo?._id, labIds);

    doctorRef.current = row.patientIpdInfo?.doctorInfo?.name;
    if (labIdsData) {
      const updatedTestData = pendingIndentData.map((test) => {
        const matchedTest = labIdsData.find((inputValues) =>
          inputValues.inputValues.some((input) => input.test === test?.test)
        );
        console.log('HELLLO SERVICE IDS DATA IS HERE', matchedTest);
        if (matchedTest) {
          const matchedService = matchedTest.inputValues.find((input) => input.test === test?.test);
          return {
            ...test,
            service: matchedService?.test,
            type: test?.testDetails?.test_name?.type,
            quantity: test.quantity,
            rate: matchedService?.['Ipd Charge'],
            amount: test.quantity * matchedService?.['Ipd Charge'],
            net_amt: test.quantity * matchedService?.['Ipd Charge'],
            disc_amt: 0,
            doctor: doctorRef.current,
            _id: matchedService?._id
          };
        }
        return test;
      });
      setPendingLabIndentDialogueOpen(false);
      setValue('ipd_no', row.ipd_no);
      setValue('patient_suffix', row?.patient?.name_suffix);
      setValue('patient_name', `${row.patient.first_name} ${row.patient.last_name}`);
      setValue('uhid', `${row.uhid}`);
      setValue('bed_no', `${row.patientIpdInfo?.consultant_detail?.bed_no}`);
      setValue('doctor', `${row.patientIpdInfo?.doctorInfo?.name}`);
      setValue('ward', `${row.wardInfo?.name}`);
      setValue('sponsor', `${row.patientInfo?.sponsorInfo?.name}`);
      setValue('age', `${calculateAge(row.patient?.dob)}`);
      setValue('room_no', row.roomInfo.room_no);
      setValue('indent_no', row.indent_no);
      setDetailList(updatedTestData);
    }
  };

  useEffect(() => {
    if (pendingServiceIndentDataObj.data && pendingServiceIndentDataObj.data.length > 0) {
      setOriginalIndentData(pendingServiceIndentDataObj.data);
      setIsFiltered(false);
    }
  }, [pendingServiceIndentDataObj.data]);

  useEffect(() => {
    handleIndentInput();
  }, [indentInput]);

  const handleIndentInput = () => {
    const lowercasedInput = indentInput.toLowerCase();
    const filtered = pendingServiceIndentDataObj.data.filter(
      (item) =>
        item.ipd_no.toString().toLowerCase().includes(lowercasedInput) ||
        item.patientInfo.first_name.toLowerCase().includes(lowercasedInput)
    );
    setOriginalIndentData(filtered);
  };

  const handleChangeIndent = (e) => {
    const newInput = e.target.value;
    setIndentInput(newInput);
  };

  useEffect(() => {
    handleIndentInputs();
  }, [indentInputs]);

  const handleIndentInputs = () => {
    const lowercasedInput = indentInputs.toLowerCase();
    const filtered = pendingLabIndentDataObj.data.filter(
      (item) =>
        item.ipd_no.toString().toLowerCase().includes(lowercasedInput) ||
        item.patientInfo.first_name.toLowerCase().includes(lowercasedInput)
    );
    setOriginalIndentDatas(filtered);
  };

  const handleChangeIndents = (e) => {
    const newInput = e.target.value;
    setIndentInputs(newInput);
  };


  const handleStartChangeDate =(e)=>{
    setStartDateInput(e.target.value)
   }
  
   const handleEndChangeDate =(e)=>{
    setEndDateInput(e.target.value)
   }
  
   const handleSearchByDate= async()=>{
    setIpdBillingDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput ;
        query.endDate = endDateInput;
      }
      const response = await request('/ipd-billing-list', {
        method: 'GET',
        query: query
      });
  
      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setIpdBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setIpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setIpdBillingDataObj({ loading: false, data: [] });
    }
    
   }
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                IPD Billing
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>

                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={TodayBilling}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Today Billing
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setPendingServiceIndentDialogueOpen(true);
                    fetchIpdPatient();
                  }}
                >
                  Service Indent
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setPendingLabIndentDialogueOpen(true);
                    fetchIpdPatients();
                  }}
                >
                  Lab Indent
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>IPD No.</Typography>
                    <TextField sx={{ flex: 0.7 }} name="ipd_no" disabled />
                    <Button
                      disabled={!['new'].includes(currentAction)}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={() => setIPDSearchDialogOpen(true)}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField disabled sx={{ flex: 0.25 }} name="patient_suffix" />
                    <TextField disabled sx={{ flex: 0.55 }} placeholder="Patient Name" name="patient_name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ward No.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Ward No." name="ward" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      placeholder="Remarks"
                      name="bill.remarks"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill/SR No.</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} placeholder="App No." name="bill.sr_no" />
                    <TextField disabled sx={{ flex: 0.4 }} placeholder="Bill No." name="bill.bill_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>UHID No / Age</Typography>
                    <TextField disabled name="uhid" sx={{ flex: 0.6 }} placeholder="UHID" />
                    <TextField disabled name="age" sx={{ flex: 0.2 }} placeholder="Age" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Room/Bed No.</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} name="room_no" placeholder="Room No" />
                    <TextField disabled sx={{ flex: 0.4 }} name="bed_no" placeholder="Bed No" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Aca.Jr.Id.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Select Academic Jr." name="aca_jr_id" />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill Date/Time</Typography>
                    <TextField
                      sx={{ flex: 0.3 }}
                      type="date"
                      name="date"
                      placeholder="Date"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                    <TextField
                      sx={{ flex: 0.3 }}
                      type="time"
                      name="time"
                      placeholder="Time"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                    <TextField sx={{ flex: 0.2 }} name="indent_no" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Consultant</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="doctor" placeholder="Consultant" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="sponsor" placeholder="Sponsor" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Out Sourced</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="bill.out_sourced"
                      placeholder="Select out sourced service provider"
                      menus={YES_NO}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={1} direction="row" justifyContent="space-between">
                    <Stack spacing={1} direction="row">
                      {/* <Button variant="contained" color="grey">
                      Bill Discount
                    </Button>
                    <Button variant="contained" color="grey">
                      Medicine Print
                    </Button> */}
                    </Stack>
                    <Button
                      variant="outlined"
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('doctor')}
                      onClick={() => setAddDetailsDialogOpen(true)}
                    >
                      Add Details
                    </Button>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1 }}
                    data={(detailList && detailList.map((data) => ({ _id: data.service, ...data }))) || []}
                    columns={BILL_TABLE_HEADER}
                    size="small"
                    showDeleteAction={true}
                    onDeleteHandler={handleRowDelete}
                  />
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Pay Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="bill.pay_mode"
                      placeholder="Pay Mode"
                      menus={RECEIPT_MODE}
                      onChange={() => setValue('bank_cash', '')}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Auth Code</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="bill.auth_code"
                      placeholder="Auth Code"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty/Amt</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="bill.total_qty" placeholder="Qty" />
                    <TextField disabled sx={{ flex: 0.5 }} name="bill.total_amt" placeholder="Amt" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Disc Per/ Amt</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} name="bill.disc_per" placeholder="Disc. %" />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('bill.pay_mode')}
                      sx={{ flex: 0.4 }}
                      name="bill.disc_amt"
                      placeholder="Disc. Amt"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                    {/* <TextField disabled sx={{ flex: 0.4 }} name="bill.gst_amt" placeholder="GST Amount" /> */}
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.net_amt" placeholder="Net Amount" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>RecAmt 1&2</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={
                        !['new', 'edit'].includes(currentAction) ||
                        payMode === 'Credit' ||
                        payMode === 'Bank' ||
                        payMode === 'UPI' ||
                        payMode === 'Paytm' ||
                        payMode === 'RTGS/NEFT/Cheque' ||
                        payMode === 'Credit Card' ||
                        payMode === 'Debit Card'
                      }
                      type="number"
                      inputProps={{ min: '0', step: '0.000001' }}
                      name="bill.rec_amt_1"
                      placeholder="Amt 1"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction) || payMode === 'Credit' || payMode === 'CASH'}
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_2"
                      placeholder="Amt 2"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Recpt.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.total_recpt" placeholder="Total" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Balance Amt</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.balance_amt" placeholder="Balance Amount" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            IPD Billing Query Window
          </Typography>
          <IconButton onClick={() => {
            setOpenQueryDialog(false)
             setStartDateInput('')
             setEndDateInput('')
          }
            
            }>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{
            mt: 1,
            mb: 1,
            width: '60%',
            gap: 2,
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            From Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            variant="outlined"
            name="from_date"
            type="date"
            onChange={handleStartChangeDate}
            value={startDateInput}
          />

          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            To Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            name="to_date"
            variant="outlined"
            type="date"
            onChange={handleEndChangeDate}
            value={endDateInput}
          />
          <Button variant="contained"  disabled={!startDateInput || !endDateInput} onClick={handleSearchByDate}>Search</Button>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={ipdBillingDataObj?.data || []}
          loading={ipdBillingDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={openQueryTodayDialog}
        onClose={() => setOpenQueryTodayDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Today IPD Billing Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryTodayDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={inputToday}
            onChange={handleChangeToday}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={opdTodayBillingDataObj?.data || []}
          loading={opdTodayBillingDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryTodayDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <IpdBillingDetailForm
          chargeType="ipd_charges"
          sponsorID={sponsorIDRef.current}
          doctorID={doctorIDRef.current}
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={onDetailAddHandler}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 1 } }}
        open={IPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IPDSearchHandler onClose={() => setIPDSearchDialogOpen(false)} onAdd={searchIPDDetails} />
      </Dialog>

      <Dialog
        open={pendingServiceIndentDialogueOpen}
        onClose={() => setPendingServiceIndentDialogueOpen(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Service Indent Details
          </Typography>
          <IconButton onClick={() => setPendingServiceIndentDialogueOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Indent"
            variant="outlined"
            value={indentInput}
            onChange={handleChangeIndent}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          onClose={() => setPendingServiceIndentDialogueOpen(false)}
          columns={INDENT_TABLE_HEADER}
          data={originalIndentData || []}
          onRowClick={(row) => {
            handleRowClick(row);
          }}
        />
      </Dialog>

      <Dialog
        open={pendingLabIndentDialogueOpen}
        onClose={() => setPendingLabIndentDialogueOpen(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Lab Indent Details
          </Typography>
          <IconButton onClick={() => setPendingLabIndentDialogueOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search Indent"
            variant="outlined"
            value={indentInputs}
            onChange={handleChangeIndents}
          />
        </Stack>
        <Table
          sx={{ mt: 3 }}
          onClose={() => setPendingLabIndentDialogueOpen(false)}
          columns={LAB_INDENT_TABLE_HEADER}
          data={pendingLabIndentDataObj.data || []}
          onRowClick={(row) => {
            handleRowClicks(row);
          }}
        />
      </Dialog>
    </>
  );
};
